import React, {Component} from 'react';
import Aux from '../../components/Hoc/Aux';

class StartOverIcon extends Component {
  render () {
    return (
      <Aux>
        <button onClick={this.props.handleShowStartOverModal} className='restart'>Restart</button>
      </Aux>
    );
  }
}

export default StartOverIcon;
